import { createStore } from "solid-js/store";

export const [i18nCache, setI18nCache] = createStore({
	cache: new Map<string, string>(),
});
